module.exports = __webpack_public_path__ + "static/media/news_bg.cf990593.png";